import React, { useState } from 'react';
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaAddressCard } from 'react-icons/fa';
import "./contact.css";
import img from "../../assets/banner-image/contact-us.jpg";
import Topheader from '../topheader/Topheader';
import Navcivil from '../navbar/Navcivil';
import Footer from '../footer/Footer';
import ReCAPTCHA from "react-google-recaptcha";
import { useNavigate } from 'react-router-dom';

function Contact() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        phone: "",
        subject: "",
        message: ""
    });
    const [formStatus, setFormStatus] = useState("");
    const [error, setError] = useState("");
    const [captchaVerified, setCaptchaVerified] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleCaptchaChange = (value) => {
        if (value) {
            setCaptchaVerified(true); // Set to true when CAPTCHA is verified
        } else {
            setCaptchaVerified(false); // Set to false if not verified
        }
    };
    const validateForm = () => {
        if (!formData.fullName || !formData.email || !formData.phone || !formData.subject || !formData.message) {
            setError("All fields are required.");
            return false;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            setError("Invalid email format.");
            return false;
        }
        setError("");
        return true;
    };

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     if (validateForm()) {
    //         setFormStatus("Thanks for submitting!");
    //         setTimeout(() => setFormStatus(""), 3000);
    //         setFormData({ fullName: "", email: "", phone: "", subject: "", message: "" });
    //     }
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!captchaVerified) {
            setError("Please verify that you are not a robot.");
            return;
        }

        if (!validateForm()) return;

        setLoading(true); // Start loading

        try {
            const response = await fetch("https://demo.firstskyinfra.in/php/contact.php", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();

            if (result.status === "success") {
                navigate('/thankyou');
                setFormData({ fullName: "", email: "", phone: "", subject: "", message: "" });
            } else {
                setError(result.message);
            }
        } catch (error) {
            setError("Failed to send message.");
        } finally {
            setLoading(false); // Stop loading
        }
    };

    return (
        <>
            <Topheader />
            <Navcivil />
            <section>
                <div className="image-about">
                    {/* Background Image */}
                    <img src={img} alt="Contact Us" className="image-bg" />

                    {/* Overlay Content */}
                    <div className="overlay-about">
                        <h1 className="fade-in-text">Contact Us</h1>
                    </div>
                </div>
            </section>

            <section className="section-padding contact-section">
                <div className="container">
                    <div className="row">
                        {/* Contact Form */}
                        <div className="col-sm-6">
                            <div className="section-title-s2">
                                <span>Contact Us</span>
                                <h3>Keep In Touch</h3>
                            </div>

                            <div className="contact-form">
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="single-input form-group">
                                                <input
                                                    type="text"
                                                    name="fullName"
                                                    placeholder="Your Name"
                                                    value={formData.fullName}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <div className="single-input form-group">
                                                <input
                                                    type="email"
                                                    name="email"
                                                    placeholder="Email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <div className="single-input form-group">
                                                <input
                                                    type="text"
                                                    name="subject"
                                                    placeholder="Subject"
                                                    value={formData.subject}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <div className="single-input form-group">
                                                <input
                                                    type="tel"
                                                    name="phone"
                                                    placeholder="Phone"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-sm-12">
                                            <div className="single-input form-group">
                                                <textarea
                                                    name="message"
                                                    placeholder="Message"
                                                    value={formData.message}
                                                    onChange={handleChange}
                                                    required
                                                ></textarea>
                                            </div>
                                        </div>

                                        <div className="form-group mb-3">
                                            <ReCAPTCHA
                                                sitekey='6LeiptIqAAAAAKT6diIfDS8Wu3vU-4SEIYxA0yB3'
                                                // sitekey="6LcwRb4qAAAAAMq-olseDFdPgiJ4s48v3oLdfMIW"
                                                // sitekey="6LdyK74qAAAAAHior1ETtBZRJf6-78AZFgkPYKf3"
                                                //  // Replace with your reCAPTCHA site key
                                                onChange={handleCaptchaChange}
                                            />
                                        </div>

                                        <p className="form-message">
                                            {error && <span className="error-message">{error}</span>}
                                            {formStatus && <span className="success-message">{formStatus}</span>}
                                        </p>

                                        <div className="col-sm-12">
                                            <div className="single-input form-group">
                                                <button className="theme-btn" type="submit" disabled={loading}>
                                                    {loading ? "Sending..." : "Submit"}
                                                </button>                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        {/* Contact Info */}
                        <div className="col-sm-5 col-sm-offset-1">
                            <div className="contact-info">
                                <ul>
                                    <li>
                                        <div className="single-info">
                                            <div className="info-icon">
                                                <FaAddressCard />
                                            </div>
                                            <div className="info-content">
                                                <p>No:21, Vinayaga Nagar, Okkiyam, <br />Thoraipakkam, Chennai-600097</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="single-info">
                                            <div className="info-icon">
                                                <FaPhoneAlt />
                                            </div>
                                            <div className="info-content">
                                                <p>+91 9500167678</p>
                                                <p>044-48570414</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="single-info">
                                            <div className="info-icon">
                                                <FaEnvelope />
                                            </div>
                                            <div className="info-content">
                                                <p>info@firstskyinfra.in</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            {/* Google Map */}
                            <div className="google-map">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.362524150823!2d80.23213717373139!3d12.948638815383935!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525c55e3f61a11%3A0xb87517f7edb01765!2sFazo%20Academy!5e0!3m2!1sen!2sin!4v1739266975762!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

                                {/* <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d198710.35112897935!2d-98.51489117772236!3d38.904562823631146!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54eab584e432360b%3A0x1c3bb99243deb742!2sUnited+States!5e0!3m2!1sen!2sin!4v1471865832140"
                                    allowFullScreen=""
                                ></iframe> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
}

export default Contact;
